module.exports = __webpack_public_path__ + "img/Group 132.df9578f7.png";